<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> COR </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="color.id"
          >{{ color.id }} - {{ color.name.toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <alert
            :visible="!!error"
            dark
            type="error"
            :message="error"
            :clickClose="() => (error = '')"
          />
          <v-row>
            <v-col cols="12" xs="12" md="2">
              <v-text-field
                v-model="color.code"
                class="text-field-uppercase"
                label="Código"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="10"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="color.name"
                class="text-field-uppercase"
                label="Nome"
                dense
                outlined
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="8"> </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="blue darken-3" dark class="mt-5" @click="validate">
                <v-icon left>mdi-send</v-icon> Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import * as API from "@/api/requests/ColorRequest";
import Alert from "@/components/Alert";

export default {
  components: {
    Alert,
  },
  data: () => ({
    loading: false,
    error: "",
    color: {
      id: "",
      name: "",
      code: "",
      status: 1,
    },
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getColor(this.$route.params.id);
      }
    },
    async getColor(id) {
      this.error = "";
      // this.showLoading();
      this.loading = true;
      try {
        this.color = await API.getById(id);
      } catch (error) {
        this.color = {};
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    goToBackList() {
      this.$router.push({ name: "Color" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.color.code = this.color.code.toUpperCase();
        this.color.name = this.color.name.toUpperCase();
        this.color.status = this.color.status ? 1 : 0;
        // let data = new URLSearchParams(this.color);
        let data = { ...this.color };
        if (this.color.id === "") {
          this.post(data);
        } else {
          this.update(this.color.id, data);
        }
      }
    },
    async post(data) {
      // this.showLoading();
      this.loading = true;
      try {
        await API.post(data);
        this.goToBackList();
      } catch (error) {
        this.error = `${error.response.data.message} - ${error.response.data.color.code}: ${error.response.data.color.name}`;
      } finally {
        this.loading = false;
      }
    },
    async update(id, data) {
      this.loading = true;
      try {
        await API.update(id, data);
        this.goToBackList();
      } catch (error) {
        this.error = `${error.response.data.message} - ${error.response.data.color.code}: ${error.response.data.color.name}`;
      } finally {
        this.loading = false;
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
</style>
